import React from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";

import Signup from ".";
import { register } from "services/apiSrv";
import { registerIntermediary } from "services/authSrv";

import { show_toast } from "utils/helpers";

const SignupContainer = () => {
  const history = useHistory()
  const signup = useMutation(registerIntermediary, {
    onSuccess: (data) => {
      console.log("signuore")
      localStorage.setItem("regId", data.data)
      history.push("/verify-otp");

      show_toast(
        ` Email verification link sent to ${localStorage.getItem("REG_EMAIL")}`,
        "success"
      );
    },
    onError: async (error) => {
      let err = await error;
      
    },
  });
  console.log("SIGNUP")

  return <Signup signup={signup} />;
};

export default SignupContainer;
